export enum Role {
  ADMIN = 'ADMIN',
  SUPPLIER = 'SUPPLIER'
}
